// This file was generated using `pay js:run gql-v1 --type=fragment --name=LegalEntityCompanyVerificationDocument --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {Exact} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment LegalEntityCompanyVerificationDocumentFragment on OpenapiLegalEntityCompanyVerificationDocument {
    back {
      id
    }
    details
    details_code
    front {
      id
    }
  }
`;

export const legalEntityCompanyVerificationDocumentFragment: LegalEntityCompanyVerificationDocumentFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type LegalEntityCompanyVerificationDocumentFragmentData = {
  readonly __typename: 'OpenapiLegalEntityCompanyVerificationDocument';
  readonly details: string | null;
  readonly details_code: string | null;
  readonly back: {
    readonly __typename: 'OpenapiFile';
    readonly id: string;
  } | null;
  readonly front: {
    readonly __typename: 'OpenapiFile';
    readonly id: string;
  } | null;
};

export type LegalEntityCompanyVerificationDocumentFragmentVariables = Exact<{
  [key: string]: never;
}>;

const legalEntityCompanyVerificationDocumentFragmentPermissions = {} as const;

doc.permissions = legalEntityCompanyVerificationDocumentFragmentPermissions;

export type LegalEntityCompanyVerificationDocumentFragmentPermissions =
  V1PermissionToken<
    typeof legalEntityCompanyVerificationDocumentFragmentPermissions
  >;

export type LegalEntityCompanyVerificationDocumentFragmentDocument =
  GraphQlDocument<
    LegalEntityCompanyVerificationDocumentFragmentData,
    LegalEntityCompanyVerificationDocumentFragmentVariables,
    LegalEntityCompanyVerificationDocumentFragmentPermissions
  >;
